import { Button, Table } from "antd";
import { Trash2 } from "lucide-react";
import { AppEmpty } from "../../components/Feedback.jsx";
import { formatDate } from "../../utils/date.js";

export function ScoreTable({ scores, onView, onRemove }) {
  return (
    <Table
      rowKey="id"
      dataSource={scores}
      pagination={false}
      scroll={{ x: 640 }}
      locale={{ emptyText: <AppEmpty description="등록된 성적이 없습니다." /> }}
      columns={[
        { title: "시험", render: (_, score) => <Button type="link" size="small" onClick={() => onView(score)}>{score.title}</Button> },
        { title: "과목", dataIndex: "subject" },
        { title: "점수", render: (_, score) => `${score.score}/${score.maxScore}` },
        { title: "날짜", render: (_, score) => formatDate(score.date) },
        { title: "레벨", dataIndex: "level" },
        { title: "첨부", render: (_, score) => `${score.files?.length || 0}개` },
        { title: "", width: 52, align: "center", render: (_, score) => <Button danger type="text" size="small" icon={<Trash2 size={15} />} onClick={() => onRemove(score.id)} aria-label={`${score.title || "시험 기록"} 삭제`} title="삭제" /> }
      ]}
    />
  );
}

export function ConsultationTable({ consultations, onView, onRemove }) {
  return (
    <Table
      rowKey="id"
      dataSource={consultations}
      pagination={false}
      locale={{ emptyText: <AppEmpty description="상담 기록이 없습니다." /> }}
      columns={[
        { title: "상담 일시", render: (_, item) => <Button type="link" size="small" onClick={() => onView(item)}>{formatDate(item.date)}</Button> },
        { title: "분류", dataIndex: "type" },
        { title: "상담 내용", dataIndex: "content" },
        { title: "첨부파일", render: (_, item) => `${(item.files || item.photos || []).length}개` },
        { title: "", width: 52, align: "center", render: (_, item) => <Button danger type="text" size="small" icon={<Trash2 size={15} />} onClick={() => onRemove(item.id)} aria-label={`${item.type || "상담 기록"} 삭제`} title="삭제" /> }
      ]}
    />
  );
}
